import { useNavigate } from 'react-router-dom';
import '../style/nextdestination.css';
import Footer from '../components/footer';

function NextDestination() {
  const navigate = useNavigate();
  
  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <div className="next-destination-page">
      <h1>Next Destination</h1>
      <div className="destination-container">
        <div className="destination-flag">?</div>
        <h2 className="destination-name"></h2>
        <p className="destination-year">2026</p>
      </div>
      <Footer />
    </div>
  );
}

export default NextDestination;